import React, { useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles } from 'transfix-ui/core'
import { useImpersonation } from 'apps/user/components/UserDetails/User/hooks/useImpersonation'
import { SystemModal } from 'components/SystemModal'
import 'scss/5_components/_footer.scss'

const useFooterStyles = makeStyles({
  impersonationButton: {
    position: 'absolute',
    top: '1rem',
    left: 0,
    right: 0,
    zIndex: 1,
    width: '200px',
    margin: 'auto',
  },
})

export const Footer = () => {
  const [open, setOpen] = useState(false)
  const toggleFlagsModalHandler = () => setOpen(!open)
  const footerText = `Copyright © ${new Date().getFullYear()} Transfix, Inc. All Rights Reserved.`

  const styles = useFooterStyles()

  const { isImpersonating, stopImpersonation } = useImpersonation()

  return (
    <footer className='cf'>
      <Button variant='text' noPadding onClick={toggleFlagsModalHandler}>
        {footerText}
      </Button>
      {open && <SystemModal open={open} close={toggleFlagsModalHandler} />}
      {isImpersonating && (
        <Button className={styles.impersonationButton} onClick={stopImpersonation}>
          Stop Impersonating
        </Button>
      )}
    </footer>
  )
}

export default Footer
